<template>
		<el-row class="bannerbox">
			<!--动态将图片轮播图的容器高度设置成与图片一致-->
			<el-carousel :height="bannerHeight + 'px'">
				<!--遍历图片地址,动态生成轮播图-->
				<el-carousel-item v-for="(item,index) in bannerlist" :key="index">
					<img :src="item.url" alt="">
				</el-carousel-item>
			</el-carousel>
		</el-row>
</template>

<script>
 export default {
        name: "Banner",
        data(){
          return{
            // 图片地址数组
			bannerlist: [
				{url:require('@/assets/image/home/banner1.jpg')},
				{url:require('@/assets/image/home/banner2.jpg')},
				{url:require('@/assets/image/home/banner3.jpg')},
				],
            // 图片父容器高度
            bannerHeight :1000,
            // 浏览器宽度
            screenWidth :0,
          }
        },
        methods:{
          setSize:function () {
            // 通过浏览器宽度(图片宽度)计算高度
            this.bannerHeight = 580 / 1920 * this.screenWidth;
          },
        },
      mounted() {
          // 首次加载时,需要调用一次
          this.screenWidth =  window.innerWidth;
          this.setSize();
          // 窗口大小发生改变时,调用一次
          window.onresize = () =>{
          this.screenWidth =  window.innerWidth;
          this.setSize();
        }
      }
}
</script>

<style lang="less" scoped>

		.bannerbox {
			width: 100%;
			height: auto;

			img {
				width: 100%;
				// height: 100%;
			}
		}
</style>
